import React, { useState, useEffect } from 'react';
import app from '../utils/base'
import { createContext } from 'react';
import Axios from 'axios';
import { API_URL } from './constants';

export const AuthContext=createContext();

export const AuthProvider=({children})=>{
    const [currentUser,setCurrentUser]=useState(null);
    const [token,setToken]=useState('');
    useEffect(() => {
        app.auth().onAuthStateChanged(setCurrentUser);
        
    }, [])
    useEffect(()=>{
        const peditJWT=async ()=>{
            // console.log(currentUser)
            if(currentUser!==null){
                const r=await Axios.get(`${API_URL}/token/${currentUser.uid}`);
                setToken(r.data.token)
            }
            
        }
        peditJWT();
    },[currentUser])
    return (
        <AuthContext.Provider
            value={{
                currentUser,
                token
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}